import { App } from "antd";
import { useTranslation } from "react-i18next";
import CopyIcon from "@/assets/copy.svg?react";
import { useCurrentApp } from "@/hooks/useCurrentApp";
import { CredentialField } from "./CredentialField";
import { IconBtn } from "../../../../components/IconBtn";

export function ModuleIdField() {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const app = useCurrentApp();
  const moduleId = app.module_id || app.app_id;

  const copy = async () => {
    await navigator.clipboard?.writeText(moduleId);
    message.success(t("credentials.copiedModuleId"));
  };

  return (
    <CredentialField
      label={t("credentials.moduleId")}
      hint={t("credentials.moduleIdHint")}
    >
      <span className="font-mono text-sm text-primary">{moduleId}</span>
      <IconBtn label={t("common.copy")} onClick={copy}>
        <CopyIcon />
      </IconBtn>
    </CredentialField>
  );
}
